import { AnchorHTMLAttributes, forwardRef } from 'react'
import { Slot, Slottable } from '@radix-ui/react-slot'

import { cn } from '@/lib/utils'

export type LinkProps = AnchorHTMLAttributes<HTMLAnchorElement> & {
  asChild?: boolean
}

const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ children, className, asChild = false, ...props }, ref) => {
    const Component = asChild ? Slot : 'a'

    return (
      <Component
        ref={ref}
        className={cn(
          '-m-[1rem] inline-flex items-center p-[1rem] font-gillsans uppercase text-copper',
          'before:mr-[0.6rem] before:block before:h-[0.5rem] before:w-[0.5rem] before:rounded-full before:bg-current',
          'after:ml-[0.6rem] after:block after:h-[0.5rem] after:w-[0.5rem] after:scale-0 after:rounded-full after:bg-current',
          '[&>span]:transition-transform [&>span]:duration-300 [&>span]:ease-out-cubic',
          'before:transition-transform before:duration-300 before:ease-out-cubic',
          'after:transition-transform after:duration-300 after:ease-out-cubic',
          'hover:before:-translate-x-[1rem] hover:before:scale-0 hover:after:-translate-x-[1rem] hover:after:scale-100',
          '[&>span]:hover:-translate-x-[1.1rem]',
          className
        )}
        {...props}
      >
        <Slottable>{children}</Slottable>
      </Component>
    )
  }
)

export default Link
